import * as React from "react";
import { Divider } from "antd";
import { formSetValue, useCpFormValue } from "../../../gvc/testNewForm/utils";
import { ContainerInput } from "../../../../schema/types/workload/input";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpDescription } from "../../../gvc/testNewForm/CpDescription";
import { CpRadioCardGroup } from "../../../gvc/testNewForm/CpRadioCardGroup";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpInputNumber } from "../../../gvc/testNewForm/CpInputNumber";
import { store } from "../../../../store";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";
import { cloneDeep } from "lodash";
import { CpLabelDirtyIndicator } from "../../../gvc/testNewForm/CpLabelDirtyIndicator";
import { Only } from "../only";

interface Props {
  index: number;
}
export const WorkloadContainerGPU: React.FC<Props> = React.memo(({ index }) => {
  const { id } = useCpFormContext();

  const gpu = useCpFormValue(`containers.${index}.gpu`);
  React.useEffect(() => {
    if (gpu.type === "none") {
      return;
    }

    // disable gpu on other containers
    const form = store.getState().form.instances[id];

    const containers = cloneDeep(form.values.containers) as ContainerInput[];
    for (const cIndexStr in containers) {
      const cIndex = Number(cIndexStr);
      if (cIndex === index) {
        continue;
      }
      formSetValue(id, `containers.${cIndex}.gpu.type`, "none");
    }
  }, [gpu]);

  return (
    <>
      <Divider orientation={`left`} orientationMargin={0}>
        GPU
        <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
          <CpLabelDirtyIndicator name={`containers.${index}.gpu`} />
        </Only>
      </Divider>
      <CpFormItem>
        <CpDescription>Only one of the containers can utilize GPU.</CpDescription>
        <div style={{ maxWidth: 900 }}>
          <CpRadioCardGroup
            name={`containers.${index}.gpu.type`}
            grid
            gridCols={3}
            options={[
              {
                label: "None",
                value: "none",
                boldLabel: true,
                children: <div>No GPU is attached</div>,
              },
              {
                label: "NVIDIA",
                value: "nvidia",
                boldLabel: true,
                children: <div>Attach NVIDIA T4 or A10</div>,
              },
              {
                label: "Custom",
                value: "custom",
                boldLabel: true,
                children: <div>Attach GPU with custom definition, only valid for BYOK locations</div>,
              },
            ]}
          />
        </div>
      </CpFormItem>
      {gpu.type === "custom" ? (
        <>
          <CpFormItem>
            <CpLabel name={`containers.${index}.gpu.custom.resource`}>
              Resource
              <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                <CpLabelDirtyIndicator name={`containers.${index}.gpu.custom.resource`} />
              </Only>
            </CpLabel>
            <CpInput name={`containers.${index}.gpu.custom.resource`} style={{ width: 450 }} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`containers.${index}.gpu.custom.runtimeClass`}>
              Runtime Class
              <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                <CpLabelDirtyIndicator name={`containers.${index}.gpu.custom.runtimeClass`} />
              </Only>
            </CpLabel>
            <CpInput name={`containers.${index}.gpu.custom.runtimeClass`} style={{ width: 450 }} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`containers.${index}.gpu.custom.quantity`}>
              Quantity
              <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                <CpLabelDirtyIndicator name={`containers.${index}.gpu.custom.quantity`} />
              </Only>
            </CpLabel>
            <CpInputNumber name={`containers.${index}.gpu.custom.quantity`} style={{ width: 450 }} />
          </CpFormItem>
        </>
      ) : null}
      {gpu.type === "nvidia" ? (
        <>
          <CpFormItem>
            <CpLabel name={`containers.${index}.gpu.nvidia.model`}>
              Model
              <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                <CpLabelDirtyIndicator name={`containers.${index}.gpu.nvidia.model`} />
              </Only>
            </CpLabel>
            <CpRadioCardGroup
              name={`containers.${index}.gpu.nvidia.model`}
              options={[
                {
                  label: "T4",
                  value: "t4",
                  children: <div></div>,
                },
                {
                  label: "A10G",
                  value: "a10g",
                  children: <div></div>,
                },
              ]}
            />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`containers.${index}.gpu.nvidia.quantity`}>
              Quantity
              <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                <CpLabelDirtyIndicator name={`containers.${index}.gpu.nvidia.quantity`} />
              </Only>
            </CpLabel>
            <CpInputNumber name={`containers.${index}.gpu.nvidia.quantity`} />
          </CpFormItem>
        </>
      ) : null}
    </>
  );
});
